// extracted by mini-css-extract-plugin
export default {"main":"backdrop_main__9jHPQ"};